// Validation regex patterns
export const NAME_REGEX = /^[A-Za-z\s-]+$/;
export const MOBILE_REGEX = /^(\+?61|0)4(\d{8})$/;
export const PHONE_REGEX = /^\+?[0-9]+$/;
export const ORG_PHONE_REGEX = /^(\+?61|0|1)([2-9]\d{4,8})$/;
export const POSTCODE_REGEX = /^[0-9]{4}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ORGANISATION_NAME_MAX_LENGTH = 100;
export const TASK_NOTES_MAX_LENGTH = 250;
